module.exports = __webpack_public_path__ + "static/media/dassault.54e10a95.png";